import { ErrorBoundary, QueryProvider, ThemeProvider } from "@app/providers";
import { router } from "@app/router";
import { RouterProvider } from "react-router-dom";

function App() {
  return (
    <ErrorBoundary>
      <QueryProvider>
        <ThemeProvider>
          <RouterProvider router={router} />
        </ThemeProvider>
      </QueryProvider>
    </ErrorBoundary>
  );
}

export default App;
